export type FieldKey =
  | "category"
  | "gigTitle"
  | "experience"
  | "description"
  | "location"
  | "workLocationType"
  | "address"
  | "contractType"
  | "period"
  | "payUnit"
  | "rate"

export type FieldErrors = Partial<Record<FieldKey, string>>

/** Maximum number of characters allowed in the job description. */
export const DESCRIPTION_MAX = 2000

export interface JobFormValues {
  category: string
  gigTitle: string | null
  experience: string
  description: string
  location: string
  workLocationType: string
  address: string
  contractType: string
  dateFrom: string
  dateTo: string
  rateType: string
  rate: string
  confidentialRate: boolean
}

/** Fields that belong to each wizard step, in order. */
export const STEP_FIELDS: FieldKey[][] = [
  ["category", "gigTitle", "experience"],
  ["contractType", "period"],
  ["payUnit", "rate"],
  ["location", "workLocationType", "address"],
  ["description"],
]

export const STEP_TITLES = ["Rol", "Durată", "Plată", "Locație", "Detalii"]

export const STEP_SUBTITLES = [
  "Ce post cauți să umpli",
  "Cât ține contractul",
  "Cât și pe ce unitate",
  "Unde se desfășoară",
  "Descriere și fotografii",
]

/** Returns the subset of errors that belong to the given step. */
export const errorsForStep = (errors: FieldErrors, step: number): FieldErrors => {
  const keys = STEP_FIELDS[step] ?? []
  const subset: FieldErrors = {}
  keys.forEach((k) => {
    if (errors[k]) subset[k] = errors[k]
  })
  return subset
}

/** Validates every field and returns a map of field -> error message. */
export const validateFields = (v: JobFormValues): FieldErrors => {
  const errors: FieldErrors = {}

  if (!v.category) errors.category = "Alege o categorie."
  if (!v.gigTitle) errors.gigTitle = "Alege o poziție."
  if (!v.experience) errors.experience = "Alege nivelul de experiență."
  if (!v.description.trim()) errors.description = "Adaugă o descriere a jobului."
  else if (v.description.length > DESCRIPTION_MAX)
    errors.description = `Descrierea poate avea maximum ${DESCRIPTION_MAX} de caractere.`

  if (!v.contractType) errors.contractType = "Alege tipul perioadei."
  if (v.contractType === "DETERMINATE" && (!v.dateFrom || !v.dateTo))
    errors.period = "Alege perioada (început și sfârșit)."
  if (!v.location) errors.location = "Alege orașul."
  if (!v.workLocationType) errors.workLocationType = "Alege modul de lucru."
  if (v.workLocationType === "AT_ADDRESS" && !v.address)
    errors.address = "Adaugă adresa exactă."

  if (!v.rateType) errors.payUnit = "Alege unitatea de plată."
  if (!v.confidentialRate && !v.rate) errors.rate = "Adaugă salariul sau marchează-l confidențial."

  return errors
}
